import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { AdItem } from '@sbt-web/network/types';
import { LoadingSkeleton } from '@sbt-web/ui';
import { AdItemCardMiniSkeleton } from '@sbt-web/item-card';
import FavoritesContainer from '@/client/components/Search/Containers/FavoritesContainer';
import { useTrackImpression } from '@/tools/tracking/useTrackImpression';
import { RecommenderCard } from './RecommenderCard';
import '@sbt-web/item-card/dist/index.css';
import styles from './index.module.scss';
type Props = {
  title: string;
  items: Array<AdItem>;
  isLoading?: boolean;
  onClick?: (item: AdItem, index: number) => void;
  onCardImpression?: (item: AdItem, index: number) => void;
  onImpression?: () => void;
  titleClass?: string;
};
export const RecommenderGridView = t0 => {
  const $ = _c(29);
  const {
    title,
    items,
    isLoading,
    onClick,
    onCardImpression,
    onImpression,
    titleClass: t1,
    children
  } = t0;
  const titleClass = t1 === undefined ? "headline-6" : t1;
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);
  let t2;
  if ($[0] !== onImpression) {
    t2 = {
      enabled: true,
      threshold: 0.05,
      track: () => onImpression?.()
    };
    $[0] = onImpression;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const setComponentRef = useTrackImpression(t2);
  let t3;
  let t4;
  if ($[2] !== isVisible || $[3] !== setComponentRef) {
    t3 = () => {
      if (isVisible && componentRef?.current) {
        setComponentRef(componentRef.current);
      }
    };
    t4 = [setComponentRef, componentRef, isVisible];
    $[2] = isVisible;
    $[3] = setComponentRef;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== items.length) {
    t5 = () => {
      if (items.length) {
        setIsVisible(true);
      }
    };
    $[6] = items.length;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== items) {
    t6 = [items];
    $[8] = items;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useEffect(t5, t6);
  if (!isLoading && items.length === 0) {
    return children;
  }
  if (isLoading) {
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <RecommenderGridViewSkeleton />;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    return t7;
  }
  const t7 = `${titleClass} ${styles.title}`;
  let t8;
  if ($[11] !== t7 || $[12] !== title) {
    t8 = <h5 className={t7}>{title}</h5>;
    $[11] = t7;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== items || $[15] !== onCardImpression || $[16] !== onClick) {
    let t10;
    if ($[18] !== onCardImpression || $[19] !== onClick) {
      t10 = (item, index) => <li key={item.urn} className={styles["grid-item"]}><RecommenderCard item={item} onClick={() => onClick?.(item, index)} onImpression={() => onCardImpression?.(item, index)} lazyLoad={index >= 4} /></li>;
      $[18] = onCardImpression;
      $[19] = onClick;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    t9 = items.map(t10);
    $[14] = items;
    $[15] = onCardImpression;
    $[16] = onClick;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <ul className={styles["grid-view"]}>{t9}</ul>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8) {
    t11 = <FavoritesContainer><section ref={componentRef} className={styles["recommender-widget"]}>{t8}{t10}</section></FavoritesContainer>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== children || $[27] !== t11) {
    t12 = <>{t11}{children}</>;
    $[26] = children;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export const RecommenderGridViewSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h5 className={`headline-6 ${styles.title}`}><LoadingSkeleton width="50%" height="24px" /></h5>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className={styles["recommender-widget"]}>{t0}<div className={styles["grid-view"]}>{Array.from({
          length: 8
        }).map(_temp)}</div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(_, index) {
  return <AdItemCardMiniSkeleton key={index * 2} imageSizeType="responsive" aspectRatio="4/5" />;
}